import { render, staticRenderFns } from "./modelDatabase.vue?vue&type=template&id=2f67b62d&"
import script from "./modelDatabase.vue?vue&type=script&lang=js&"
export * from "./modelDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports